import { useNavigate, useParams } from "react-router-dom";
import { Shell, Card } from "../components/Layout";
import { Button } from "../components/ui/button";
import { SEDES } from "../lib/api";

export function SedeSelect() {
  const navigate = useNavigate();
  return (
    <Shell accent="logo" title="Logopedia"
      subtitle="Seleccione en primer lugar la sede a la que desea acudir. Cada sede dispone de su propio horario."
      testid="sede-select-page">
      <div className="grid gap-8 md:grid-cols-2">
        {Object.entries(SEDES).map(([key, label]) => (
          <Card key={key}>
            <h2 className="font-head text-3xl font-medium">{label}</h2>
            <p className="mt-3 text-lg text-ink-700">
              Sesiones de 45 minutos a partir de las 15:30 h, con dos consultas disponibles en cada
              franja. Atención los {key === "xalo" ? "martes y jueves" : "lunes y miércoles"}.
            </p>
            <Button data-testid={`sede-${key}-btn`} onClick={() => navigate(`/logopedia/${key}`)}
              className="mt-6 h-14 w-full bg-logo text-lg hover:bg-logo-hover">
              Seleccionar la sede de {label}
            </Button>
          </Card>
        ))}
      </div>
    </Shell>
  );
}

export function SedeHome() {
  const { sede } = useParams();
  const navigate = useNavigate();
  const label = SEDES[sede] || sede;
  return (
    <Shell accent="logo" title={`Logopedia — Sede de ${label}`} testid="sede-home-page">
      <div className="grid gap-8 md:grid-cols-2">
        <Card className="flex flex-col justify-between">
          <h2 className="font-head text-2xl font-medium">Es mi primera vez</h2>
          <Button data-testid="start-alta-btn" onClick={() => navigate(`/logopedia/${sede}/alta`)}
            className="mt-8 h-14 w-full bg-logo text-lg hover:bg-logo-hover">
            Registrar un paciente
          </Button>
        </Card>
        <Card className="flex flex-col justify-between">
          <h2 className="font-head text-2xl font-medium">Ya soy paciente</h2>
          <Button data-testid="logo-login-btn" variant="outline" onClick={() => navigate("/entrar")}
            className="mt-8 h-14 w-full text-lg">Acceder a mi cuenta</Button>
        </Card>
      </div>
    </Shell>
  );
}
